const FirebaseConfig = {
  apiKey: "AIzaSyDyMwidCd2IeYVNfpwBFlg648xnXZBOWJQ",
  authDomain: "my-git-app-e896a.firebaseapp.com",
  projectId: "my-git-app-e896a",
  storageBucket: "my-git-app-e896a.appspot.com",
  messagingSenderId: "913230164123",
  appId: "1:913230164123:web:37daad1bba1d20d4ce563e",
  measurementId: "G-VB71BFGL73"
};

export default FirebaseConfig;